import React, { useContext } from "react";
import { DropFileIcon } from "./Icons";
import { Box, Stack, Text } from "@origin-digital/ods-core";
import { MessageContext } from "./MessageContext";
import styled from "styled-components";
import { isMessageAttachmentValid } from "./helpers";
import { MessageAttachment } from "./types";
import { normalizeFileName } from "../helper";

const WithDropEventListener = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: stretch;
`;

const MessageFileDropZone = () => {
  const { setMessageTabState } = useContext(MessageContext);

  const handleError = (message: string) => {
    setMessageTabState((prevMessageTabState) => ({
      ...prevMessageTabState,
      displaySnackbar: {
        message,
        tone: "critical",
      },
    }));
  };

  const onDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const file = e.dataTransfer.files?.[0];
    if (e.dataTransfer.files.length > 1) {
      handleError("Please drop one file at a time.");
      return;
    }
    if (!isMessageAttachmentValid({ file, handleError })) {
      return;
    }
    setMessageTabState((prevMessageTabState) => ({
      ...prevMessageTabState,
      showDocumentTypeDialog: true,
      showFileDropZone: false,
      selectedAttachments: [
        ...prevMessageTabState.selectedAttachments,
        {
          file,
          fileName: normalizeFileName(file!.name),
        } as MessageAttachment,
      ],
    }));
  };

  const onDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setMessageTabState((prevMessageTabState) => ({
      ...prevMessageTabState,
      displaySnackbar: undefined,
    }));
  };

  return (
    <WithDropEventListener onDrop={onDrop} onDragOver={onDragOver}>
      <Box
        display="flex"
        alignItems="center"
        backgroundColor="grey50"
        border="2px dashed #0A5FD2"
        pointerEvents="none"
        style={{ maxHeight: "148px" }}
      >
        <Stack space="xlarge">
          <Box padding="large">
            <Stack space="medium" alignX="center">
              <Box
                backgroundColor="grey100"
                padding="xsmall"
                style={{ borderRadius: "56px", height: "48px" }}
              >
                <DropFileIcon />
              </Box>
              <Stack space="xsmall">
                <Text align="center" weight="medium">
                  Drop file here
                </Text>
                <Text align="center" variant="body-small" tone="neutralLight">
                  Max file size: 5MB. One file at a time.
                </Text>
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Box>
    </WithDropEventListener>
  );
};

export default MessageFileDropZone;
